/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { OpenAPIObject } from "openapi3-ts";

export const FETCH_SWAGGER_REQUEST = 'FETCH_SWAGGER_REQUEST';
export const FETCH_SWAGGER_SUCCESS = 'FETCH_SWAGGER_SUCCESS';
export const FETCH_SWAGGER_FAILURE = 'FETCH_SWAGGER_FAILURE';

export interface SwaggerAction {
    type: typeof FETCH_SWAGGER_REQUEST | typeof FETCH_SWAGGER_SUCCESS | typeof FETCH_SWAGGER_FAILURE,
    payload?: OpenAPIObject | string
}
